import ShopAddressSettingsModal from './shop-address-settings-modal';

export default ShopAddressSettingsModal;
